'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.geoComply = void 0;
var adapter_1 = require("../adapter");
var GeoComply = /** @class */ (function () {
    function GeoComply() {
    }
    /**
     * Gets the license of geocomply required to make calls from frontend.
     */
    GeoComply.prototype.getLicense = function (refresh) {
        return adapter_1.adapter.geoComply.getLicense({ refresh: refresh });
    };
    /**
     * Check if the response coming from GeoComply is authorized
     */
    GeoComply.prototype.authorize = function (response) {
        return adapter_1.adapter.geoComply.authorize({ response: response });
    };
    return GeoComply;
}());
exports.geoComply = new GeoComply();
